module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHABohOu+oGgAAANVJREFUWMPtV8sOwzAIA2v//8veqRLamtU8qkhTc8kFsEnAJE7SqsvdSdKtsWCbFzrZx33bCYxfgZrRAazar+xeZ4EP41/ZZYFXsVBhHQN2SfqqDaNz5Z5VfyjFla30DHmoFV4pNuXkcFebqX7ekeKtSvh/BKK2d/V9VZxn88PNjNMFmBEkkPQIpChctSM+cUj60wUPAWRbaNJWIlDVBNVPfpCobZmdoJgEr5BAB1x5sl0qYXWmK/8C5eS+lDDz3VJez1dxy1KcAb9ViLZ9zaam5nYpfgMbSrQzTxKk8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_c.png
// module id = xQou
// module chunks = 1